(function () {
  function initWallPreview(section) {
    if (!section || section.dataset.initialized === "true") return;
    section.dataset.initialized = "true";

    const stage = section.querySelector("[data-wall-preview]");
    const toggles = Array.from(section.querySelectorAll("[data-toggle-target]"));
    const buttons = Array.from(section.querySelectorAll("[data-action]"));
    const groups = Array.from(section.querySelectorAll(".fnr-wall-preview__group"));

    if (!stage) return;

    function isMobile() {
      return window.innerWidth <= 767;
    }

    function clearAction(action) {
      section.querySelectorAll('[data-action="' + action + '"]').forEach((el) => {
        el.classList.remove("is-active");
      });
    }

    function closeAllPanels() {
      groups.forEach((group) => {
        const toggle = group.querySelector(".fnr-wall-preview__toggle");
        const panel = group.querySelector(".fnr-wall-preview__options");

        if (toggle) toggle.classList.remove("is-open");
        if (panel) panel.classList.remove("is-open");
      });
    }

    function openPanel(group) {
      const toggle = group.querySelector(".fnr-wall-preview__toggle");
      const panel = group.querySelector(".fnr-wall-preview__options");

      if (toggle) toggle.classList.add("is-open");
      if (panel) panel.classList.add("is-open");
    }

    function applyDesktopDefaultState() {
      if (isMobile()) return;

      groups.forEach((group, index) => {
        const toggle = group.querySelector(".fnr-wall-preview__toggle");
        const panel = group.querySelector(".fnr-wall-preview__options");

        if (!toggle || !panel) return;

        if (index === 0) {
          toggle.classList.add("is-open");
          panel.classList.add("is-open");
        } else {
          toggle.classList.remove("is-open");
          panel.classList.remove("is-open");
        }
      });
    }

    function applyMobileDefaultState() {
      if (!isMobile()) return;
      closeAllPanels();
    }

    function setMood(value) {
      stage.classList.remove("is-mode-light", "is-mode-dark-ambient", "is-mode-dark-spotlight");

      if (value === "dark-ambient") {
        stage.classList.add("is-mode-dark-ambient");
      } else if (value === "dark-spotlight") {
        stage.classList.add("is-mode-dark-spotlight");
      } else {
        stage.classList.add("is-mode-light");
      }

      stage.classList.remove("is-shade-on");
      stage.classList.add("is-shade-off");

      clearAction("blinds");
      const blindsOff = section.querySelector('[data-action="blinds"][data-value="off"]');
      if (blindsOff) blindsOff.classList.add("is-active");
    }

 function setTexture(value) {
  stage.classList.remove("is-wall-solid", "is-wall-linen", "is-wall-limewash", "is-wall-concrete", "is-wall-paper");

  if (value === "background-01") {
    stage.style.setProperty("--wallpaper-paper", "var(--wall-background-01)");
    stage.classList.add("is-wall-paper");
  } else if (value === "background-02") {
    stage.style.setProperty("--wallpaper-paper", "var(--wall-background-02)");
    stage.classList.add("is-wall-paper");
  } else if (value === "background-03") {
    stage.style.setProperty("--wallpaper-paper", "var(--wall-background-03)");
    stage.classList.add("is-wall-paper");
  } else if (value === "background-04") {
    stage.style.setProperty("--wallpaper-paper", "var(--wall-background-04)");
    stage.classList.add("is-wall-paper");
  } else if (value === "background-05") {
    stage.style.setProperty("--wallpaper-paper", "var(--wall-background-05)");
    stage.classList.add("is-wall-paper");
  } else if (value === "background-06") {
    stage.style.setProperty("--wallpaper-paper", "var(--wall-background-06)");
    stage.classList.add("is-wall-paper");
  } else if (value === "background-07") {
    stage.style.setProperty("--wallpaper-paper", "var(--wall-background-07)");
    stage.classList.add("is-wall-paper");
  } else {
    stage.classList.add("is-wall-solid");
  }
}

    function setBlinds(value) {
      stage.classList.remove("is-shade-on", "is-shade-off");
      stage.classList.add(value === "on" ? "is-shade-on" : "is-shade-off");

      if (value === "on") {
        stage.classList.remove("is-mode-dark-ambient", "is-mode-dark-spotlight");
        stage.classList.add("is-mode-light");

        clearAction("mood");
        const moodLight = section.querySelector('[data-action="mood"][data-value="light"]');
        if (moodLight) moodLight.classList.add("is-active");
      }
    }

    toggles.forEach((toggle) => {
      toggle.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        const targetId = this.getAttribute("data-toggle-target");
        const target = section.querySelector("#" + CSS.escape(targetId));
        const group = this.closest(".fnr-wall-preview__group");

        if (!target || !group) return;

        const isOpen = target.classList.contains("is-open");

        if (isMobile()) {
          closeAllPanels();

          if (!isOpen) {
            openPanel(group);
          }
        } else {
          closeAllPanels();
          openPanel(group);
        }
      });
    });

    buttons.forEach((button) => {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        const action = this.getAttribute("data-action");
        const value = this.getAttribute("data-value");

if (action === "wall-color") {
  clearAction("wall-color");
  this.classList.add("is-active");
  stage.style.setProperty("--wall-color", value);

  clearAction("texture");
  const defaultTexture = section.querySelector('[data-action="texture"][data-value="reset"]');
  if (defaultTexture) defaultTexture.classList.add("is-active");
  setTexture("reset");
}

        if (action === "texture") {
          clearAction("texture");
          this.classList.add("is-active");
          setTexture(value);
        }

        if (action === "blinds") {
          clearAction("blinds");
          this.classList.add("is-active");
          setBlinds(value);
        }

        if (action === "mood") {
          clearAction("mood");
          this.classList.add("is-active");
          setMood(value);
        }

        if (isMobile()) {
          setTimeout(() => {
            closeAllPanels();
          }, 140);
        }
      });
    });

    document.addEventListener("click", function (event) {
      if (!isMobile()) return;
      if (event.target.closest("#" + section.id + " .fnr-wall-preview__controls")) return;
      closeAllPanels();
    });

    window.addEventListener("resize", function () {
      if (isMobile()) {
        applyMobileDefaultState();
      } else {
        applyDesktopDefaultState();
      }
    });

    if (isMobile()) {
      applyMobileDefaultState();
    } else {
      applyDesktopDefaultState();
    }
  }

  function initAllWallPreviews() {
    document.querySelectorAll(".fnr-wall-preview").forEach(initWallPreview);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllWallPreviews);
  } else {
    initAllWallPreviews();
  }

  document.addEventListener("shopify:section:load", initAllWallPreviews);
})();